// Must run before anything renders: pins all date display to the business
// timezone (Asia/Kathmandu) regardless of the viewer's browser timezone.
import "@utils/timezone";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "@store";
import { ThemeProvider } from "@emotion/react";
import "react-toastify/dist/ReactToastify.css";
import "./global.css";
import { ToastContainer } from "react-toastify";
import theme from "@utils/theme";
import { ModalProvider } from "@context/ModalContext";
import { DropdownProvider } from "@context/DropdownContext";
import { WebSocketProvider } from "@context/WebSocketProvider";
import ErrorBoundary from "@components/errorboundary";

import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-center" style={{ zIndex: 9999999999999 }} />
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <ModalProvider>
          <WebSocketProvider>
            <DropdownProvider>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </DropdownProvider>
          </WebSocketProvider>
        </ModalProvider>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
);
